/**
 * Pasos para exportar un crucigrama
 * 1. Generar el crucigrama en https://www.educima.com/crosswordgenerator.php
 * 2. En la página que se abre, copiar del DOM el elemento con id="crossword"
 * 3. Eliminar las etiquetas <table>, <tbody>
 * 4. Sustitutir las etiquetas <td> y <td> por <div>
 * 5. Sustituir las clases 'grid-square' por 'square' y 'crossword-row' por 'row'
 * 6. Reemplazar en el elemento los siguientes atributos
 * 6.1 Reemplazar 'class' por 'className'
 * 6.1 Reemplazar disabled="" por vacio
 * 6.2 Ajustar el 'style' en react 'style={{ textAlign: 'center' }}'
 * 6.3 Reemplazar 'maxlength="1"' por 'maxLength={1} onKeyDown={handleOnKeyDown}'
 */

import { handleOnKeyDown } from 'utils/crosswords.utils';

export const Crossword7 = (
    <div className="center crossword" id="crossword" style={{ textAlign: 'center' }}>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="1"
                    data-across="undefined"
                    data-down="2"
                />
                <span className="num">1</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                />
                <span className="num">2</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="4"
                    data-across="3"
                    data-down="2"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="K"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="4"
                    data-across="3"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="V"
                    data-num="1"
                    data-across="undefined"
                    data-down="2"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="3"
                    data-across="2"
                    data-down="undefined"
                />
                <span className="num">3</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="3"
                    data-across="2"
                    data-down="2"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="3"
                    data-across="2"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="3"
                    data-across="2"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                />
                <span className="num">4</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="1"
                    data-across="undefined"
                    data-down="2"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="1"
                    data-across="undefined"
                    data-down="2"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="13"
                    data-across="12"
                    data-down="13"
                />
                <span className="num">5</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="Ó"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="13"
                    data-across="12"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                />
                <span className="num">6</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="G"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="5"
                    data-across="4"
                    data-down="2"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="5"
                    data-across="4"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="1"
                    data-across="undefined"
                    data-down="2"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="B"
                    data-num="0"
                    data-across="-1"
                    data-down="undefined"
                />
                <span className="num">7</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="1"
                    data-across="-1"
                    data-down="2"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="0"
                    data-across="-1"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="2"
                    data-across="-1"
                    data-down="3"
                />
                <span className="num">8</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="2"
                    data-across="undefined"
                    data-down="3"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="10"
                    data-across="undefined"
                    data-down="11"
                />
                <span className="num">9</span>
            </div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="2"
                    data-across="undefined"
                    data-down="3"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="10"
                    data-across="undefined"
                    data-down="11"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                />
                <span className="num">10</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="K"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="K"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="7"
                    data-across="6"
                    data-down="3"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="7"
                    data-across="6"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="11"
                    data-across="10"
                    data-down="11"
                />
                <span className="num">11</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="11"
                    data-across="10"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="12"
                    data-across="10"
                    data-down="13"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="G"
                    data-num="2"
                    data-across="undefined"
                    data-down="3"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="10"
                    data-across="undefined"
                    data-down="11"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="8"
                    data-across="5"
                    data-down="9"
                />
                <span className="num">12</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    data-num="6"
                    data-across="5"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="6"
                    data-across="5"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="6"
                    data-across="5"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="6"
                    data-across="5"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="6"
                    data-across="5"
                    data-down="3"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="6"
                    data-across="5"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="6"
                    data-across="5"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="Ó"
                    data-num="6"
                    data-across="5"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="10"
                    data-across="5"
                    data-down="11"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="12"
                    data-across="undefined"
                    data-down="13"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="14"
                    data-across="undefined"
                    data-down="15"
                />
                <span className="num">14</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="F"
                    data-num="10"
                    data-across="undefined"
                    data-down="11"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    data-num="14"
                    data-across="undefined"
                    data-down="15"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="10"
                    data-across="undefined"
                    data-down="11"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    data-num="14"
                    data-across="undefined"
                    data-down="15"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="10"
                    data-across="undefined"
                    data-down="11"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="14"
                    data-across="undefined"
                    data-down="15"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    data-num="8"
                    data-across="undefined"
                    data-down="9"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    data-num="10"
                    data-across="undefined"
                    data-down="11"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    data-num="14"
                    data-across="8"
                    data-down="15"
                />
                <span className="num">15</span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="9"
                    data-across="8"
                    data-down="9"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="B"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    data-num="9"
                    data-across="8"
                    data-down="undefined"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    data-num="10"
                    data-across="undefined"
                    data-down="11"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="14"
                    data-across="undefined"
                    data-down="15"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="Ó"
                    data-num="10"
                    data-across="undefined"
                    data-down="11"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    data-num="14"
                    data-across="undefined"
                    data-down="15"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    data-num="10"
                    data-across="undefined"
                    data-down="11"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square active">
                <input
                    type="text"
                    className="char charReadOnly"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    data-num="14"
                    data-across="undefined"
                    data-down="15"
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
    </div>
);
